import {
  BookingSubStepOption,
  BookingSubStepOptionEnum,
} from '../../components/BookingWidget/bookingSteps.interface';

const resolveDestinationByCatalogThenValue = (
  destinationValue: string,
  options: BookingSubStepOption[],
  selectedCatalogCode?: string,
): BookingSubStepOption | undefined => {
  const normalizedDestinationValue = destinationValue.toLowerCase();
  const optionsMatchingValue = options.filter(
    (option) =>
      option[BookingSubStepOptionEnum.Value].toLowerCase() ===
      normalizedDestinationValue,
  );

  if (optionsMatchingValue.length === 0) {
    return undefined;
  }

  if (selectedCatalogCode) {
    const optionMatchingCatalog = optionsMatchingValue.find(
      (option) =>
        option[BookingSubStepOptionEnum.CatalogSpecific]?.some(
          (catalog) => catalog.code === selectedCatalogCode,
        ),
    );

    if (optionMatchingCatalog) {
      return optionMatchingCatalog;
    }
  }

  return optionsMatchingValue[0];
};

export default resolveDestinationByCatalogThenValue;
